/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface Extraction
 */
export interface Extraction {
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    extractionParentId?: number;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof Extraction
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof Extraction
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    endOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof Extraction
     */
    score?: number;
}

/**
 * Check if a given object implements the Extraction interface.
 */
export function instanceOfExtraction(value: object): boolean {
    return true;
}

export function ExtractionFromJSON(json: any): Extraction {
    return ExtractionFromJSONTyped(json, false);
}

export function ExtractionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Extraction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'extractionParentId': json['extractionParentId'] == null ? undefined : json['extractionParentId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'label': json['label'] == null ? undefined : json['label'],
        'value': json['value'] == null ? undefined : json['value'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
        'score': json['score'] == null ? undefined : json['score'],
    };
}

export function ExtractionToJSON(value?: Extraction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'utteranceId': value['utteranceId'],
        'extractionParentId': value['extractionParentId'],
        'contactId': value['contactId'],
        'label': value['label'],
        'value': value['value'],
        'startOffset': value['startOffset'],
        'endOffset': value['endOffset'],
        'score': value['score'],
    };
}

